<template>
  <v-container class="hidePost">
    <v-layout row wrap>
      <v-flex xs9>
        <v-list-tile-content class="hideMessage" data-qe-id="hidden-post_hidden-message">
          {{communityCommonConstant.post.HIDE_MESSAGE}}
        </v-list-tile-content>
      </v-flex>
      <v-flex xs3 text-xs-right>
        <v-btn id="undo_unitTest" class="primary_btn transparent" flat @click="unHidePosts" data-qe-id="hidden-post_unhide_btn">
            {{communityCommonConstant.post.UNDO}}
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
    import { communityCommonConstant } from '../communityCommon.constant';
    import { mapActions } from "vuex";
    import { storeAction } from '@/store/storeActions.constant';

export default {
  name: 'ActivityPost',
  data: () => ({
    communityCommonConstant,
  }),
  props: {
    activity: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions('chapter', [storeAction.unHidePost]),
    unHidePosts() {
      this.unHidePost(this.activity.id);
    },
  },
  computed: {
    ownerName() {
      return `${this.activity.authorFirstName} ${this.activity.authorLastName}`;
    },
  },
};
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';

.hidePost {
  background: rgba($ypo-title-border, 0.3);
  border: 1px solid rgba($ypo-title-border, 0.6);
  border-radius: 4px;
  margin: 0 0 15px 0;
  padding: 5px 0 5px 0;
  font-size: 12px;
  
  .hideMessage{
    color: $black;
    font-family: "Noto Sans";
    font-size: 14px;
    margin-left: 20px;
  }
}

</style>
